import React from "react";
import { useProductionStore } from "../../../stores/production";
import { afficherTousLesMois } from "../../../services/function";

const DetailsForSuperviseur = () => {
  const { production2, isLoading } = useProductionStore();
  const months = afficherTousLesMois();

  return (
    <div className="space-y-4 w-full h-full ">
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
        </div>
      ) : (
        production2?.customerFiles?.map((clientFile: any) => (
          <React.Fragment key={clientFile.name}>
            <div className="text-xl font-bold text-left w-full">
              {clientFile.name}
            </div>
            {clientFile.missions.map((mission: any) => (
              <table
                key={`${clientFile.name}-${mission.name}`}
                className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl"
              >
                <React.Fragment>
                  <thead className="mt-2">
                    <tr>
                      <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-80">
                        {mission.name.toUpperCase()}
                      </th>
                      <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-24">
                        ANTERIEUR
                      </th>
                      {months?.map((month: any) => (
                        <th
                          key={month}
                          className="border border-gray-300 px-4 py-2 bg-thead text-left w-24"
                        >
                          {month.toUpperCase()}
                        </th>
                      ))}
                      <th className="border border-gray-300 px-4 py-2 bg-thead/50 text-left w-24">
                        TOTAL
                      </th>
                      <th className="border border-gray-300 px-4 py-2 bg-thead/50 text-left w-24">
                        BUDGET
                      </th>
                      <th className="border border-gray-300 px-4 py-2 bg-thead/50 text-left w-24">
                        DIFFERENCE
                      </th>
                    </tr>
                  </thead>
                </React.Fragment>
                {mission.users.map((user: any) => (
                  <tbody key={user.id} className="h-12">
                    <tr className="h-12 px-4 py-2" key={user.id}>
                      <td className="border border-gray-300 px-4 py-2 text-left w-80">
                        {user.name}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-left w-24">
                        {user?.anterieurHour}
                      </td>
                      {months?.map((month: any) => (
                        <td className="border border-gray-300 px-4 py-2 text-left w-24">
                          {mission.months
                            .find(
                              (monthMission: any) =>
                                monthMission.name === month,
                            )
                            ?.users?.find(
                              (userMonth: any) => userMonth.id === user.id,
                            )?.temps ??
                            mission.months
                              .find(
                                (monthMission: any) =>
                                  monthMission.name === month,
                              )
                              ?.users?.find(
                                (userMonth: any) => userMonth.id === user.id,
                              )?.totalHour ??
                            ""}
                        </td>
                      ))}
                      <td className="border border-gray-300 px-4 py-2 text-left w-24">
                        {user.totalHour}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-left w-24"></td>
                      <td className="border border-gray-300 px-4 py-2 text-left w-24"></td>
                    </tr>
                  </tbody>
                ))}
                <tfoot>
                  <tr className="border-gray-300 bg-gray-200 h-8 w-full">
                    <td className="border border-gray-300 px-4 py-2 text-left w-80">
                      Total
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-left w-24">
                      {mission.totalAnterieurHours}
                    </td>
                    {months?.map((month: any) => (
                      <td className="border border-gray-300 px-4 py-2 text-left w-24">
                        {mission.months
                          .find(
                            (monthMission: any) => monthMission.name === month,
                          )
                          ?.users?.reduce(
                            (acc: number, user: any) => acc + user.temps,
                            0,
                          )}
                      </td>
                    ))}
                    <td className="border border-gray-300 px-4 py-2 text-left w-24">
                      {mission.users.reduce(
                        (acc: number, user: any) => acc + user.totalHour,
                        0,
                      )}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-left w-24">
                      {mission.budgetTime}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-left w-24">
                      {mission.diff}
                    </td>
                  </tr>
                </tfoot>
              </table>
            ))}
          </React.Fragment>
        ))
      )}
    </div>
  );
};

export default DetailsForSuperviseur;
